import { NgModule, isDevMode } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {MatExpansionModule} from '@angular/material/expansion';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
//import {provideClientHydration} from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import {GuidedTourModule, GuidedTourService} from 'ngx-guided-tour';
import { HighlighterPipe } from './highlighter.pipe';

import {
  LandingComponent,
  FooterComponent,
  DashboardComponent,
  BaniDashboardComponent,
  SearchComponent,
  HeaderComponent,
  SidenavContentComponent,
  ModalVideoComponent,
  IntroductionComponent,
  BaniSubDetailsComponent,
  SignificantTermsComponent,
  SignificantTermsDetailComponent,
  OverviewComponent,
  ApproachComponent,
  GlossaryComponent,
  ContentCitationComponent,
  CorrectionComponent,
  BibliographyComponent,
  ProjectComponent,
  TranscriptionGuidelinesComponent,
  TeamComponent,
  SiteMapComponent,
} from './components/components';
import { RequestInterceptor } from './core/interceptors/request-interceptor';
import { GuruGranthSahibComponent } from './components/guru-granth-sahib/guru-granth-sahib.component';
import { DictionaryComponent } from './components/dictionary/dictionary.component';
import { MethodologyComponent } from './components/methodology/methodology.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { NewsComponent } from './components/news/news.component';
import { ArticlesComponent } from './components/articles/articles.component';
import { PressReleasesComponent } from './components/press-releases/press-releases.component';
import { CitationGuideComponent } from './components/citation-guide/citation-guide.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { NewReleaseComponent } from './components/new-release/new-release.component';
import { OnboardingDialogComponent } from './components/onboarding-dialog/onboarding-dialog.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CommonModule } from '@angular/common';
import { BaniDetailsAdminComponent } from './components/bani-details-admin/bani-details-admin.component';
import { ArticleDetailComponent } from './components/article-details/article-details.component';
import { NewsletterComponent } from './components/newsletter/newsletter.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    FooterComponent,
    DashboardComponent,
    OnboardingDialogComponent,
    BaniDashboardComponent,
    SearchComponent,
    HeaderComponent,
    SidenavContentComponent,
    ModalVideoComponent,
    IntroductionComponent,
    BaniSubDetailsComponent,
    SignificantTermsComponent,
    SignificantTermsDetailComponent,
    OverviewComponent,
    ApproachComponent,
    GlossaryComponent,
    ContentCitationComponent,
    CorrectionComponent,
    BibliographyComponent,
    ProjectComponent,
    TranscriptionGuidelinesComponent,
    TeamComponent,
    SiteMapComponent,
    GuruGranthSahibComponent,
    DictionaryComponent,
    MethodologyComponent,
    NavigationComponent,
    NewsComponent,
    ArticlesComponent,
    ArticleDetailComponent,
    PressReleasesComponent,
    CitationGuideComponent,
    PrivacyPolicyComponent,
    CopyrightComponent,
    TermsOfUseComponent,
    ContactUsComponent,
    NewReleaseComponent,
    HighlighterPipe,
    PageNotFoundComponent,
    BaniDetailsAdminComponent,
    NewsletterComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ShareButtonsModule,
    MatExpansionModule,
    ShareIconsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    InfiniteScrollModule,
    MatTabsModule,
    MatIconModule,
    CarouselModule,
    MatGridListModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatSelectModule,
    MatSidenavModule,
    MatDialogModule,
    MatTableModule,
    GuidedTourModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),

  ],
  providers: [GuidedTourService,
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
//provideClientHydration(),